export default {
    state: {
        enabled: false
    },

    actions: {
        switchDarkMode(context) {
            if (context.state.enabled) {
                context.commit("disableDarkMode");
                localStorage.setItem("darkMode", context.state.enabled)
            } else {
                context.commit("enableDarkMode");
                localStorage.setItem("darkMode", context.state.enabled)
            }
        }
    },

    mutations: {
        enableDarkMode(state) {
            console.log("This is dark time for us");
            state.enabled = true;
        },

        disableDarkMode(state) {
            console.log("This is light time for us");
            state.enabled = false;
        }
    },

    getters: {
        darkModeIsEnabled() {
            return localStorage.getItem("darkMode") === "true";
        }
    }
}